import { combineReducers } from "redux";
import { authReducer } from "./auth-reducers";
import { globalStateReducer } from "./global-state-reducer";
import { alertsReducer } from "./alerts-reducer";
import { userReducer } from "./user-reducer";
import { roleReducer } from "./role-reducer";
import { departmentReducer } from "./department-reducers";
import { groupingReducer } from "./grouping-reducer";
import { articleReducer } from "./article-reducers";
import { newsReducer } from "./news-reducers";
import { projectReducer } from "./project-reducers";
import { SliderReducer } from "./slider-reducers";
import { infoReducer } from "./site-info-reducers";
import { faqReducer } from "./faq-reducers";
import { usefulLinksReducer } from "./useful-links-reducer";
import { usefulLinkGroupsReducer } from "./useful-link-groups-reducer";
import { detailReducer } from "./detail-reducer";
import { newTokenReducer } from "./new-token-reducer";
import { resetPasswordReducer } from "./reset-password-reducer";
import { cooperationReducer } from "./cooperation-reducers";
import { notificationReducer } from "./notification-reducer";
import { cooperationReqReducer } from "./cooperation-request-reducer";
import { cooperationAppricantsReducer } from "./cooperation-appricants-reducers";
import { catalogReducer } from "./catalog-reducers";

export const rootReducer = combineReducers({
  auth: authReducer,
  globalState: globalStateReducer,
  alert: alertsReducer,
  user: userReducer,
  role: roleReducer,
  department: departmentReducer,
  grouping: groupingReducer,
  article: articleReducer,
  news: newsReducer,
  project: projectReducer,
  slider: SliderReducer,
  info: infoReducer,
  faq: faqReducer,
  usefulLinks: usefulLinksReducer,
  usefulLinkGroups: usefulLinkGroupsReducer,
  detail: detailReducer,
  newToken: newTokenReducer,
  resetPassword: resetPasswordReducer,
  cooperation: cooperationReducer,
  notification: notificationReducer,
  cooperationReq: cooperationReqReducer,
  cooperationsAppricants: cooperationAppricantsReducer,
  catalog: catalogReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
